import { MaterialReactTable } from 'material-react-table'
import React, { useEffect, useState } from 'react'
import { MemberListState, useAdTeamStore } from 'src/stores/AdTeamStore'
import Icon_Trash from 'src/assets/images/Icon_Trash.svg'

const TableHeaderSx = {
  backgroundColor: '#30515B',
  color: 'white',
  fontSize: '14px',
  textAlign: 'center',
  '& .Mui-TableHeadCell-Content': {
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    height: '100%',
  },
  '&:first-of-type': {
    borderTopLeftRadius: '5px',
    borderBottomLeftRadius: '5px',
  },
  '&:last-of-type': {
    borderTopRightRadius: '5px',
    borderBottomRightRadius: '5px',
  },
}

const TableCellSx = {
  textAlign: 'center',
  verticalAlign: 'middle',
  fontSize: '16px',
}

const ModalCreateTeamTable = () => {
    const setField = useAdTeamStore((state)=>state.setField)
    const memberList = useAdTeamStore((state)=>state.memberList)
    const [data,setData] = useState<MemberListState[]>([])
    // const [selectedRowIndex, setSelectedRowIndex] = useState<number>(0);

    useEffect(()=>{
      setData(memberList)
    },[memberList])

    const onClickDeleteMember = (rowData:any)=>{
      const updatedList = memberList.filter((row) => row.uid !== rowData.uid);
      setField('memberList', updatedList);
    }

    return (
        <div style={{width:'100%'}}>
            <MaterialReactTable
                enableStickyHeader
                data={data}
                muiTableContainerProps={{
                sx: { flex: 1, overflowY: 'auto', height:'263px' }
                }}
                columns={[
                { accessorKey:'user_name', header: '이름'},
                { accessorKey:'user_id',header: '아이디'},
                { accessorKey:'phone',header:'연락처'},
                { id: 'deleteAction', header:'',size:50,
                  Cell: ({ row }) => (
                    <button
                      style={{
                        all:'unset',
                        padding: '4px 8px',
                        // backgroundColor: '#508A9C',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer',
                      }}
                      onClick={() => {
                        onClickDeleteMember(row.original)
                      }}
                    >
                      <img src={Icon_Trash} alt='TrashBin'/>
                    </button>
                  ),
                }
                ]}
                // 툴바, sort 버튼 등
                enableSorting={false} // ✅ 전체 정렬 기능 제거
                enableTopToolbar={false}
                enableBottomToolbar={false}
                enableColumnActions={false}
                muiTablePaperProps={{
                elevation: 0, // ✅ 그림자 제거
                }}
                // 로우 헤더 스타일
                muiTableHeadCellProps={{
                sx: TableHeaderSx,
                }}
                // 로우 스타일
                muiTableBodyRowProps={({ row }) => ({
                    sx: {
                        cursor: 'pointer',
                        height: '49px',
                        '& > td:first-of-type': {
                        borderTopLeftRadius: '5px',
                        borderBottomLeftRadius: '5px',
                        // borderTop: row.index === selectedRowIndex ? '1px solid #229596' : 'none',
                        },
                        '& > td:last-of-type': {
                        borderTopRightRadius: '5px',
                        borderBottomRightRadius: '5px',
                        // borderRight: row.index === selectedRowIndex ? '1px solid #229596' : 'none',
                        },
                        '& > td': {
                        boxShadow: '1px 2px 2px 0 rgba(0, 0, 0, 0.1)',
                        padding: '4px',
                        // backgroundColor: row.index === selectedRowIndex ? '#E0EBEB' : '#FFF',
                        // borderTop: row.index === selectedRowIndex ? '1px solid #229596' : 'none',
                        // borderBottom: row.index === selectedRowIndex ? '1px solid #229596' : 'none',
                        },
                    },
                })}
                // 셀 스타일
                muiTableBodyCellProps={{
                sx: TableCellSx,
                }}
                // 테이블 스타일
                muiTableProps={{
                sx: {
                    borderCollapse: 'separate',
                    borderSpacing: '0 5px', // ✅ row 간격 5px
                    '& .MuiTableSortLabel-icon': {
                    color: '#aaa',
                    fontSize: '1.5rem',
                    },
                    '& .MuiTableSortLabel-root.Mui-active .MuiTableSortLabel-icon': {
                    color: 'rgb(255, 255, 255) !important',
                    },
                }}}
                // 페이지 네이션 옵션
                manualPagination 
                // 솔팅 옵션
                manualSorting
                enableSortingRemoval={false}
                // 플레이스홀더
                renderEmptyRowsFallback={() => (
                    <div style={{   height: '49px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    borderRadius: '5px',
                                    boxShadow: '1px 2px 2px 0 rgba(0, 0, 0, 0.1)',
                                    padding: '4px',
                                    color: '#999', }}>
                    팀원을 추가해 주세요.
                    </div>
                )}
                />
        </div>
    )
}

export default ModalCreateTeamTable